























import { Component, Vue, Prop } from 'vue-property-decorator';
import { TextBlock } from './components';
import { IData } from './types';

@Component({
  components: {
    TextBlock,
  },
})
export default class Data extends Vue implements IData {
  @Prop({ type: String, default: '' })
  readonly childName!: string;

  @Prop({ type: String, default: '' })
  readonly certificateNumber!: string;

  @Prop({ type: String, default: '' })
  readonly certificateDateEnd!: string;

  @Prop({ type: Boolean, default: false })
  readonly isSertificateConfirmed!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/data/Data.vue